import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import RequestAccessModal from './RequestAccessModal';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogin = () => {
    window.location.href = 'https://app.alpenglowstudio.net';
  };

  const handleContact = () => {
    window.location.href = 'https://alpenglowstudio.com/contact-us';
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#0a2e2e]/95 backdrop-blur-md shadow-lg border-b border-[#8b956d]/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_excalibur-login/artifacts/xx3h8d4i_Excalibur.png"
              alt="Excalibur Logo"
              className="h-12 w-auto transition-transform duration-300 hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              onClick={handleContact}
              variant="ghost"
              className="text-[#c5c9b8] hover:text-[#8b956d] hover:bg-[#8b956d]/10 transition-colors duration-300"
            >
              Contact Us
            </Button>
            <Button
              onClick={handleLogin}
              className="bg-[#8b956d] hover:bg-[#9ca878] text-[#0a2e2e] font-semibold px-6 py-2 rounded-md transition-all duration-300 hover:shadow-lg hover:shadow-[#8b956d]/30 hover:scale-105"
            >
              Login
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#c5c9b8] hover:text-[#8b956d] transition-colors duration-300"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#0a2e2e]/98 backdrop-blur-md border-t border-[#8b956d]/20">
          <div className="px-4 py-4 space-y-3">
            <Button
              onClick={handleContact}
              variant="ghost"
              className="w-full text-[#c5c9b8] hover:text-[#8b956d] hover:bg-[#8b956d]/10 transition-colors duration-300"
            >
              Contact Us
            </Button>
            <Button
              onClick={handleLogin}
              className="w-full bg-[#8b956d] hover:bg-[#9ca878] text-[#0a2e2e] font-semibold transition-all duration-300"
            >
              Login
            </Button>
          </div>
        </div>
      )}

      {/* Request Access Modal */}
      <RequestAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
};

export default Header;
